module.exports = __webpack_public_path__ + "img/hettich.6405407.svg";